/* eslint-disable array-callback-return */
import {
  Button,
  Divider,
  Row,
  Col,
  Form,
  Checkbox,
  Card,
  Skeleton,
} from 'antd';
import axios from 'axios';
import React, { useContext, useEffect, useState, useRef } from 'react';
import CheckboxTree from 'react-checkbox-tree';
import Loader from 'components/layout/Loader';
import hocFrom from 'components/forms/HocFrom';
import Switchrs from 'components/inputs/Switchrs';
import InputFarsi from 'components/inputs/InputFarsi';
import InputNumber from 'components/inputs/InputNumber';
import InputControl from 'components/inputs/InputControl';
import DashboardContext from 'Context';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import 'react-dropdown-tree-select/dist/styles.css';

const permissionCheckBoxGroupStyle = {
  display: 'flex',
  flexDirection: 'column',
  marginTop: '5%',
};

const permissionCheckBoxStyle = {
  marginRight: '10px',
  fontSize: '12px',
};

function UserForm({
  handleSendWithSimCommand,
  handleUpdateWithSimCommand,
  loding,
  dataUpdate,
  companyId,
  handelLoadingform,
}) {
  const { urldashboard, authentication, handelerrors, edit, handelEdit } =
    useContext(DashboardContext);
  const [form] = Form.useForm();
  const renderForEdit = useRef(true);
  // primary states
  const [loading, setLoading] = useState(true);
  const [loadingForm, setLoadingForm] = useState(false);
  const [formData, setFormData] = useState({});
  // secondary states
  const [isAdmin, setIsAdmin] = useState(false);
  const [treeLoading, setTreeLoading] = useState(false);
  const [adminActions] = useState([]);
  const [permissionIds] = useState([]);
  const [permissionCheck] = useState([]);
  const [expand, setExpand] = useState([]);
  const [checkAll, setCheckAll] = useState([]);
  const [checkEach, setCheckEach] = useState([]);
  const [actionsList, setActionsList] = useState([]);
  const [actionsItems, setActionsItems] = useState([]);
  const [defaultAddress, setDefaultAddress] = useState([]);

  useEffect(() => {
    getPermissions();
    if (!edit) getTreeData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (renderForEdit.current) {
      renderForEdit.current = false;
      return;
    }

    if (dataUpdate?.roleId) getUserDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUpdate]);

  useEffect(() => {
    adminActions?.length < 1 &&
      actionsList?.map((res) =>
        res?.actions?.map((resp) => adminActions.push(resp?.id))
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin]);

  const getTreeData = async () => {
    setTreeLoading(true);
    try {
      const response = await axios.get(
        `${urldashboard}/B2BUser/create/${companyId}`,
        {
          headers: {
            Authorization: authentication,
            'content-type': 'application/json; charset=utf-8',
          },
        }
      );
      const data = await response?.data?.data;
      setDefaultAddress(
        data
          ?.filter((res) => res?.addressSections?.length > 0)
          ?.map((add) => ({
            label: add.addressName,
            value: add.addressId,
            showCheckbox: false,
            children: add.addressSections?.map((secs) => ({
              label: secs?.addressSectionName,
              value: add.addressId + '/' + secs?.addressSectionId,
              disabled: false,
              showCheckbox: true,
              children: secs?.addressSectionBusinessGroups?.map((groups) => ({
                label: groups?.addressSectionBusinessGroupName,
                value: groups?.addressSectionBusinessGroupId,
                disabled: false,
                showCheckbox: true,
              })),
            })),
          }))
      );

      response?.data?.data
        ?.filter((res) => res?.addressSections?.length > 0)
        ?.map((add) => {
          setExpand((prevState) => [...prevState, add?.addressId]);
          add?.addressSections
            ?.filter((resp) => resp?.addressSectionBusinessGroups?.length > 0)
            ?.map((sec) => {
              sec?.addressSectionBusinessGroups?.map((group) => {
                setCheckAll((prevState) => [
                  ...prevState,
                  group?.addressSectionBusinessGroupId,
                ]);
                setExpand((prevState) => [
                  ...prevState,
                  group?.addressSectionBusinessGroupId,
                ]);
              });
            });
        });
      setTreeLoading(false);
    } catch (error) {
      setTreeLoading(false);
      handelerrors(error);
    }
  };

  const getUserDetails = () => {
    setLoading(true);
    if (dataUpdate?.roleId === '2ff98e84-8c95-40a4-6439-08dbbf14d3e9') {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }

    setDefaultAddress(
      dataUpdate?.businessUserAddressSectionBusinessGroupModels
        ?.filter((res) => res?.addressSections?.length > 0)
        ?.map((add) => ({
          label: add.addressName,
          value: 'parent' + add.addressId,
          showCheckbox: false,
          children: add.addressSections?.map((secs) => ({
            label: secs?.addressSectionName,
            value: 'parent' + secs?.addressSectionId,
            disabled: false,
            showCheckbox: true,
            children: secs?.addressSectionBusinessGroups?.map((groups) => ({
              label: groups?.addressSectionBusinessGroupName,
              value: groups?.addressSectionBusinessGroupId,
              disabled: false,
              showCheckbox: true,
            })),
          })),
        }))
    );

    dataUpdate?.permissionListResponse?.forEach((perm) => {
      perm?.actions
        ?.filter((res) => res?.isSelect === true)
        ?.forEach((item) => {
          permissionIds.push(item?.id);
          actionsItems?.push(item?.id);
        });
    });

    dataUpdate?.permissionListResponse?.forEach((perm) => {
      perm?.actions?.forEach((item) => {
        permissionCheck.push(item?.id);
      });
    });

    dataUpdate?.businessUserAddressSectionBusinessGroupModels?.forEach(
      (businessUserAddressSectionBusinessGroupModel) => {
        if (
          businessUserAddressSectionBusinessGroupModel.addressSections.length >
          0
        )
          setExpand((prevState) => [
            ...prevState,
            '' + businessUserAddressSectionBusinessGroupModel.addressId,
          ]);
        businessUserAddressSectionBusinessGroupModel.addressSections.forEach(
          (addressSection) => {
            if (
              addressSection.isSelect === true &&
              addressSection.addressSectionBusinessGroups.length
            )
              setExpand((prevState) => [
                ...prevState,
                'parent' + addressSection.addressSectionId,
              ]);
            addressSection.addressSectionBusinessGroups.forEach(
              (addressSectionBusinessGroup) => {
                if (addressSectionBusinessGroup.isSelect === true)
                  setCheckEach((prevState) => [
                    ...prevState,
                    addressSectionBusinessGroup.addressSectionBusinessGroupId,
                  ]);
              }
            );
          }
        );
      }
    );

    dataUpdate?.businessUserAddressSectionBusinessGroupModels?.forEach(
      (businessUserAddressSectionBusinessGroupModel) => {
        setExpand((prevState) => [
          ...prevState,
          'parent' + businessUserAddressSectionBusinessGroupModel.addressId,
        ]);
        businessUserAddressSectionBusinessGroupModel.addressSections.forEach(
          (addressSection) => {
            if (
              addressSection?.addressSectionBusinessGroups.filter(
                (res) => res?.isSelect === true
              )
            )
              setExpand((prevState) => [
                ...prevState,
                'parent' + addressSection.addressSectionId,
              ]);
            addressSection.addressSectionBusinessGroups.forEach(
              (addressSectionBusinessGroup) => {
                setCheckAll((prevState) => [
                  ...prevState,
                  addressSectionBusinessGroup.addressSectionBusinessGroupId,
                ]);
              }
            );
          }
        );
      }
    );
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  const onExpand = (data) => {
    setExpand(data);
  };

  const onCheck = (data) => {
    setCheckEach(data);
  };

  const getPermissions = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urldashboard}/accesses/getB2BPermissions`,
        {
          headers: {
            Authorization: authentication,
            'content-type': 'application/json; charset=utf-8',
          },
        }
      );
      const data = await response?.data?.data;
      setLoading(false);
      setActionsList(data);
    } catch (error) {
      setLoading(false);
      handelerrors(error);
    }
  };

  const onSubmit = () => {
    handelLoadingform(true);

    const command = {
      companyId,
      ...formData,
      permissionIds: isAdmin ? adminActions : actionsItems,
      addressSectionBusinessGroupIds: isAdmin ? checkAll : checkEach,
    };

    const editCommand = {
      userId: dataUpdate?.id,
      companyId,
      firstName: formData?.firstName ?? dataUpdate?.firstName,
      lastName: formData?.lastName ?? dataUpdate?.lastName,
      parentId: formData?.parentId ?? dataUpdate?.parentId,
      phoneNumber: formData?.phoneNumber ?? dataUpdate?.phoneNumber,
      roleId: formData?.roleId ?? dataUpdate?.roleId,
      isActive: formData?.isActive ?? dataUpdate?.isActive,
      isAdmin,
      permissionIds: isAdmin ? permissionCheck : actionsItems,
      addressSectionBusinessGroupIds: isAdmin
        ? checkAll
        : checkEach?.filter((res) => res?.slice(0, 6) !== 'parent'),
    };

    if (edit) {
      handleUpdateWithSimCommand(editCommand);
      handelEdit('');
      handelLoadingform(false);
    } else {
      handleSendWithSimCommand(command);
      handelLoadingform(false);
    }

    setLoadingForm(false);
  };

  const onChange = (checkedValues) => {
    setActionsItems(checkedValues);
  };

  return (
    <>
      {loding || loading ? (
        <Loader />
      ) : (
        <>
          <Form form={form} name='form' onFinish={onSubmit} layout='vertical'>
            <Divider>{edit ? 'ویرایش اطلاعات کاربر' : 'کاربر جدید'}</Divider>
            <Row gutter={20}>
              <Col xl={8} lg={8} md={12} sm={24} xs={24}>
                <Form.Item
                  className='form-group'
                  rules={[{ required: true, message: 'نام کاربر الزامی است.' }]}
                >
                  <InputFarsi
                    label='نام'
                    defaultValue={dataUpdate?.firstName}
                    handelValue={(_, value) =>
                      setFormData({ ...formData, firstName: value })
                    }
                    name='firstName'
                  />
                </Form.Item>
              </Col>
              <Col xl={8} lg={8} md={12} sm={24} xs={24}>
                <Form.Item
                  className='form-group'
                  rules={[
                    {
                      required: true,
                      message: 'نام خانوادگی کاربر الزامی است.',
                    },
                  ]}
                >
                  <InputFarsi
                    label='نام خانوادگی'
                    defaultValue={dataUpdate?.lastName}
                    name='lastName'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, lastName: value })
                    }
                  />
                </Form.Item>
              </Col>
              <Col xl={8} lg={8} md={12} sm={24} xs={24}>
                <Form.Item className='form-group'>
                  <InputNumber
                    label='شماره موبایل'
                    defaultValue={dataUpdate?.phoneNumber}
                    name='phoneNumber'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, phoneNumber: value })
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={20}>
              <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                <Form.Item className='form-group'>
                  <InputControl
                    url='/roles/b2bdropdown'
                    label='نقش'
                    name='roleId'
                    defaultValue={dataUpdate?.roleId}
                    disabled={
                      dataUpdate?.roleId ===
                      '2ff98e84-8c95-40a4-6439-08dbbf14d3e9'
                    }
                    handelValue={(_, value) => {
                      setFormData({ ...formData, roleId: value });
                      setIsAdmin(
                        value === '2ff98e84-8c95-40a4-6439-08dbbf14d3e9'
                          ? true
                          : false
                      );
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                <Form.Item className='form-group'>
                  <InputControl
                    url={`/B2BUser/dropdown/${companyId}`}
                    label='سرپرست مسئول'
                    name='parentId'
                    defaultValue={dataUpdate?.parentId}
                    handelValue={(_, value) =>
                      setFormData({ ...formData, parentId: value })
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row className='my-5'>
              <Col span={24}>
                <Divider>{'دسترسی‌ها'}</Divider>
                <Checkbox.Group
                  style={{
                    display: 'flex',
                    width: '100%',
                    flexWrap: 'wrap',
                    alignItems: 'stretch',
                  }}
                  value={isAdmin ? adminActions : actionsItems}
                  onChange={isAdmin ? undefined : onChange}
                  disabled={dataUpdate?.isAdmin ? true : isAdmin}
                >
                  {actionsList?.map((item) => (
                    <Card
                      key={item?.controller}
                      style={{ flex: 1, margin: '0 .5rem' }}
                    >
                      <h2
                        style={{
                          padding: '1rem',
                          borderBottom: '1px solid rgb(247, 247, 247)',
                          textAlign: 'center',
                          fontWeight: 100,
                          color: '#8f8f8f',
                        }}
                      >
                        {item?.controller}
                      </h2>
                      <div style={permissionCheckBoxGroupStyle}>
                        {item?.actions?.map((action) => (
                          <Checkbox
                            style={permissionCheckBoxStyle}
                            value={action?.id}
                            key={action?.id}
                          >
                            {action?.title}
                          </Checkbox>
                        ))}
                      </div>
                    </Card>
                  ))}
                </Checkbox.Group>
              </Col>
            </Row>
            <Row className='my-5'>
              <Col span={24}>
                <Divider>{'آدرسها و بخشها'}</Divider>
                {treeLoading ? (
                  <Skeleton.Node active />
                ) : (
                  <Form.Item
                    name=''
                    style={{
                      height: 500,
                      overflowY: 'scroll',
                      border: '2px solid #f7f7f7',
                    }}
                  >
                    <CheckboxTree
                      nodes={defaultAddress}
                      checked={isAdmin ? checkAll : checkEach}
                      optimisticToggle
                      iconsClass='fa5'
                      nameAsArray={edit ? true : false}
                      expanded={expand}
                      disabled={isAdmin}
                      onCheck={onCheck}
                      onExpand={onExpand}
                      icons={{
                        check: (
                          <i
                            className='mdi mdi-checkbox-marked'
                            style={{ fontSize: '1.2rem', color: '#464dee' }}
                          />
                        ),
                        uncheck: (
                          <i
                            className='mdi mdi-checkbox-blank-outline'
                            style={{ fontSize: '1.2rem', color: '#464dee' }}
                          />
                        ),
                        halfCheck: (
                          <i
                            className='mdi mdi-minus-box'
                            style={{
                              fontSize: '1.2rem',
                              color: 'rgb(149 152 241)',
                            }}
                          />
                        ),
                        expandClose: (
                          <i
                            className='mdi mdi-chevron-left'
                            style={{ fontSize: '1.5rem' }}
                          />
                        ),
                        expandOpen: (
                          <i
                            className='mdi mdi-chevron-down'
                            style={{ fontSize: '1.5rem' }}
                          />
                        ),
                        parentClose: (
                          <i
                            className='mdi mdi-folder'
                            style={{ fontSize: '1.2rem', color: '#464dee' }}
                          />
                        ),
                        parentOpen: (
                          <i
                            className='mdi mdi-folder-open'
                            style={{ fontSize: '1.2rem', color: '#464dee' }}
                          />
                        ),
                        leaf: (
                          <i
                            className='mdi mdi-file'
                            style={{ fontSize: '1.2rem', color: '#b3b3b3' }}
                          />
                        ),
                      }}
                    />
                  </Form.Item>
                )}
              </Col>
            </Row>
            <Row className='mt-5'>
              <Col>
                <Switchrs
                  label='آیا فعال باشد؟'
                  defaultChecked={dataUpdate?.isActive}
                  checke={formData?.isActive}
                  name='isActive'
                  handelValue={(_, value) =>
                    setFormData({ ...formData, isActive: value })
                  }
                />
              </Col>
            </Row>
            <Row className='mt-5'>
              <Col>
                <Button
                  htmlType='submit'
                  className='btn btn-success mr-auto'
                  style={{ height: '3rem', width: '10rem' }}
                  disabled={loadingForm}
                >
                  {loadingForm ? (
                    <i className='fa fa-spinner fa-pulse fa-fw'></i>
                  ) : (
                    'ثبت'
                  )}
                </Button>
              </Col>
            </Row>
          </Form>
        </>
      )}
    </>
  );
}

export default hocFrom(UserForm);
